<template>
  <v-checkbox
    :input-value="value"
    :value="val"
    hide-details
    :ripple="false"
    :on-icon="onIcon"
    :off-icon="offIcon"
    class="checkbox-container"
    @change="handleChange"
  />
</template>

<script>
export default {
  props: {
    rounded: {
      type: Boolean,
      default: false
    },
    val: {
      type: [String, Number, Boolean],
      default: undefined
    },
    value: {
      type: [Boolean, Array],
      default: undefined
    }
  },
  computed: {
    onIcon() {
      if (this.rounded) {
        return 'fa-check-circle'
      }
      return undefined
    },
    offIcon() {
      if (this.rounded) {
        return 'far fa-circle'
      }
      return undefined
    }
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-container {
  margin-top: 0;
  padding-top: 0;
}
</style>
